// Shared image-URL resolver for the report pages (Grooming, Random Attendance).
// Converts a stored blob path into an /api/images/view/ URL. Extracted from the
// byte-identical guards both pages previously inlined (only the param name and a
// couple of comments differed); the returned strings are unchanged:
//   - null / empty / 'null' / 'undefined'  -> null
//   - file:// path (local device path)     -> null
//   - http(s):// absolute URL              -> returned as-is
//   - already an /api/ path                -> returned as-is
//   - otherwise -> `/api/images/view/${encodeURI(blobPath)}` (leading slashes stripped)
export const getImageViewUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  const trimmed = String(url).trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null;
  if (trimmed.startsWith('file://')) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/api/')) return trimmed;
  const blobPath = trimmed.replace(/^\/+/, '');
  return `/api/images/view/${encodeURI(blobPath)}`;
};

// CSV/export variant of getImageViewUrl: returns an ABSOLUTE (origin-prefixed)
// URL for links embedded in exported CSVs, and the '-' sentinel (not null) for
// empty/unservable values so CSV cells aren't blank. The origin prefix and '-'
// sentinel are the only differences from getImageViewUrl. Extracted from the
// byte-identical copies in GroomingReportPage + RandomAttendanceLogsPage.
// (DailyAttendanceLogsPage intentionally keeps its own simpler, guard-less variant.)
export const getFullImageViewUrl = (url: string | null | undefined): string => {
  if (!url) return '-';
  const trimmed = String(url).trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return '-';
  if (trimmed.startsWith('file://')) return '-';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/api/')) return `${window.location.origin}${trimmed}`;
  const blobPath = trimmed.replace(/^\/+/, '');
  return `${window.location.origin}/api/images/view/${encodeURI(blobPath)}`;
};
